import { useEffect, useState } from 'react'
import { useAuthLoginRoute } from '@rumah-pendidikan/auth/react'
import { AntdLayout, Button, Progress, Typography } from '@pankod/refine-antd'
import Head from 'next/head'
import Image from 'next/image'

import { resolveLoginRedirectPath } from 'src/helpers/auth/redirect'
import { BASE_PATH } from 'src/constant'

const { Title, Text } = Typography

const LOGIN_PROGRESS_UPDATES = [
  { delay: 120, percent: 8 },
  { delay: 210, percent: 86 },
  { delay: 1000, percent: 95 },
]

const LoginComponent: React.FC = () => {
  const [progress, setProgress] = useState(0)
  const fallbackRedirectPath =
    typeof window === 'undefined'
      ? '/'
      : resolveLoginRedirectPath(window.location.search)

  useEffect(() => {
    const progressTimers = LOGIN_PROGRESS_UPDATES.map(({ delay, percent }) =>
      window.setTimeout(() => setProgress(percent), delay),
    )

    return () => {
      progressTimers.forEach(window.clearTimeout)
    }
  }, [])

  useAuthLoginRoute({
    fallbackRedirectPath,
  })

  return (
    <div className="flex flex-col items-center w-full">
      <Text className="!text-gray-700">Mengalihkan ke halaman login...</Text>
      <Progress
        type="line"
        showInfo={false}
        percent={progress}
        status="active"
      />
    </div>
  )
}

const Login: React.FC = () => {
  const [isLoggingIn, setIsLoggingIn] = useState(false)

  return (
    <AntdLayout
      style={{
        background: `radial-gradient(50% 50% at 50% 50%, #bbb 0%, #333 100%)`,
        backgroundSize: 'cover',
      }}
    >
      <Head>
        <title>LMS Admin | Login</title>
      </Head>
      <div style={{ height: '100vh', display: 'flex' }}>
        <div
          style={{ margin: 'auto', textAlign: 'center' }}
          className="bg-white p-5 rounded-2xl shadow-lg"
        >
          <div
            style={{
              marginBottom: '20px',
              display: 'flex',
              justifyContent: 'space-between',
            }}
            className="items-center gap-4"
          >
            <img src={`${BASE_PATH}/logo.svg`} alt="logo" className="h-12" />
            <Title
              level={2}
              style={{
                margin: '0',
              }}
              className="!text-gray-700"
            >
              LMS Admin
            </Title>
          </div>
          <div className="flex items-center justify-center">
            {isLoggingIn ? (
              <LoginComponent />
            ) : (
              <Button
                type="primary"
                size="large"
                className="!rounded-lg"
                onClick={() => {
                  setIsLoggingIn(true)
                }}
              >
                Masuk ke LMS Admin
              </Button>
            )}
          </div>
          <Image
            alt="BSrE Logo"
            src={'/img/BSrE-logo.png'}
            width={90}
            height={30}
            className="mt-[20px]"
            style={{ objectFit: 'contain' }}
          />
        </div>
      </div>
    </AntdLayout>
  )
}

export default Login
